'use strict';

const React = require( 'react' );
const propTypes = require('prop-types');
const classNames = require( 'classnames' );
const { string, bool, object } = propTypes;
const createReactClass = require('create-react-class');

const RoomSelect = createReactClass({
  propTypes: {
    activeRoom: string,
    name: string,
    secondRoomText: string,
    secondRoom: bool,
    RoomTypes: object.isRequired,
    extraOptionText: string,
    className: string
  },

  getDefaultProps() {
    return {
      activeRoom: 'D20',
      secondRoomText: 'No, thank you',
      secondRoom: false,
      className: ''
    };
  },

  makeOption( key, val ) {
    return ( <option key={val} value={key}>{val}</option> );
  },

  makeOptions() {
    const { RoomTypes } = this.props;
    return Object.keys( RoomTypes ).map( i => {
      const text = RoomTypes[ i ];
      return this.makeOption( i, text );
    });
  },

  render() {
    const { className, secondRoom, secondRoomText, activeRoom, name, extraOptionText } = this.props;
    const rooms = this.makeOptions( );
    const secondRoomOption = secondRoom && this.makeOption( '', secondRoomText );
    const extraOption = extraOptionText && this.makeOption( '', extraOptionText );
    const trackName = 'roomtype_' + name.match(/\d+/)[0];
    const colWidth = classNames( className );
    return (
      <select name={name} className={ colWidth } defaultValue={activeRoom} data-hxtrack-name={trackName}>{secondRoomOption}{extraOption}{rooms}</select>
    );
  }
});

module.exports = RoomSelect;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/engines/rooms-dropdown.jsx